module.exports = __webpack_public_path__ + "33f919650a0487784d63cff056ae1f1f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/loyalty-banner.png
// module id = 3163
// module chunks = 0